import { Controller } from '@hotwired/stimulus'

// List keys (ux-redesign §4.2, I-OL-09): J/K focus the next/previous row (from outside the table J starts at the
// first row, K at the last); ↑/↓ do the same only while the focus is already in a row, otherwise the page scrolls.
// Enter on a focused row opens its detail ([data-row-open]); a letter clicks the element with data-hotkey="<letter>"
// („N“ = Nová zakázka). Nothing fires while typing (input, textarea, select, contenteditable), with a modifier, or
// while a dialog or a <details> dropdown is open.
export default class HotkeysController extends Controller<HTMLElement> {
  static override targets = ['row']
  declare readonly rowTargets: HTMLElement[]

  keydown(event: KeyboardEvent): void {
    if (event.defaultPrevented || event.ctrlKey || event.metaKey || event.altKey || this.ignored(event.target)) return

    const current = this.currentRow()
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      if (current !== -1) this.focusRow(event, current + (event.key === 'ArrowDown' ? 1 : -1))
    } else if (event.key === 'j' || event.key === 'k') {
      const step = event.key === 'j' ? 1 : -1
      this.focusRow(event, current === -1 ? (step > 0 ? 0 : this.rowTargets.length - 1) : current + step)
    } else if (event.key === 'Enter') {
      const row = this.rowTargets[current]
      const open = row && row === event.target ? row.querySelector<HTMLElement>('[data-row-open]') : null
      if (!open) return

      event.preventDefault()
      open.click()
    } else if (event.key.length === 1) {
      const target = this.element.querySelector<HTMLElement>(`[data-hotkey="${CSS.escape(event.key.toLowerCase())}"]`)
      if (!target) return

      event.preventDefault()
      target.click()
    }
  }

  private currentRow(): number {
    const focused = document.activeElement
    return this.rowTargets.findIndex((row) => focused instanceof Node && row.contains(focused))
  }

  // Past either end nothing moves (and the key keeps its default).
  private focusRow(event: KeyboardEvent, index: number): void {
    const row = this.rowTargets[index]
    if (!row) return

    event.preventDefault()
    row.focus()
  }

  private ignored(target: EventTarget | null): boolean {
    if (document.querySelector('dialog[open], details.dropdown[open], :popover-open')) return true

    // The closed command palette's input can keep the focus (Chrome); it is not typing.
    return target instanceof HTMLElement && !target.closest('dialog:not([open])') && (target.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName))
  }
}
